





















import { IOccupation } from '@app/componentlib/common/types/JobMatchTypes'
import { IJobGoal } from '@app/componentlib/common/types/WizardTypes'
import { JobMatchOccupationModule } from '@app/componentlib/src/store/modules/JobMatch/jobMatchOccupations'
import { AppModule } from '@app/componentlib/src/store/modules/app'
import Vue from 'vue'
import Component from 'vue-class-component'
import ReadMore from './ReadMore.vue'
import ButtonWithCheckMark from './ButtonWithCheckMark.vue'
import { IJobGoalItem } from '@app/componentlib/common/types/JobMatchTypes'

@Component<OccupationListItem>({
  props: {
    item: Object,
    source: String
  },
  components: {
    ReadMore,
    ButtonWithCheckMark
  }
})

export default class OccupationListItem extends Vue {
  /**
   * Props variables
   */
  item: IJobGoal | IOccupation | IJobGoalItem | undefined = undefined
  source: string = ''

  /**
   * Component state variables
   */
  isLoading: boolean = false

  /**
   * Lifecycle
   */
  mounted() {

  }

  /**
   * Getters
   */
  get t (): any {
    return AppModule.translations
  }

  get alternativeLabels (): any {
    // Check if item have preferredLabel which means its of type IOccupation
    if (this.item !== undefined && 'preferredLabel' in this.item && this.item.alternativeLabels !== null) {
      // Check if alternativeLabels only have 1, which could mean it comes 1 long string
      if (this.item.alternativeLabels.length === 1) {
        // Split the alternative labels into an array
        return this.item.alternativeLabels[0].split(',')
      }
      else {
        // else just set altLabels to alternativeLabels
        return this.item.alternativeLabels
      }
    }
    else {
      return []
    }
  }

  /**
   * Methods
   */
  async clickedItem() {
    if (this.item === undefined) return

    this.isLoading = true

    if (this.item.isActive === undefined) this.item.isActive = false

    var occupation = this.item as IOccupation

    // Check if item has text which means its of type IJobGoal
    if ('text' in this.item) {
      // If yes, we need to create an occupation item
      occupation = {
        label: this.item.text,
        occupationCode: this.item.occupationCode !== undefined ? this.item.occupationCode : null,
        occupationSource: this.source,
        alternativeLabels: [],
        description: "",
        preferredLabel: this.item.text,
        isActive: this.item.isActive
      } as IOccupation
    }

    occupation.occupationSource = this.source

    if (this.item.isActive === false) {
      await JobMatchOccupationModule.addOccupation(occupation).then(() => {
        this.item!.isActive = true
      })
    } else {
      await JobMatchOccupationModule.removeOccupation(occupation).then(() => {
        this.item!.isActive = false
      })
    }

    this.isLoading = false
  }

  trimLabel(label: string) {
    const tempLabel = label.replace("&#x0D;", "" )
    return tempLabel
  }
}
